/**
 * @generated SignedSource<<a2557234b9167bb2c75a3afed60ae8f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MasqInput = {
  clientMutationId?: string | null | undefined;
  userId?: string | null | undefined;
  userRawId?: number | null | undefined;
};
export type masq_masqAsUserMutation$variables = {
  input: MasqInput;
};
export type masq_masqAsUserMutation$data = {
  readonly masq: {
    readonly user: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"NavigationWrapper_User">;
    } | null | undefined;
  } | null | undefined;
};
export type masq_masqAsUserMutation = {
  response: masq_masqAsUserMutation$data;
  variables: masq_masqAsUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFlexhireTeam",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unconfirmedEmail",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "masq_masqAsUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MasqPayload",
        "kind": "LinkedField",
        "name": "masq",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NavigationWrapper_User"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "masq_masqAsUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MasqPayload",
        "kind": "LinkedField",
        "name": "masq",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "guest",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "confirmedEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "passwordSetupRequired",
                "storageKey": null
              },
              {
                "alias": "activeContracts",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "statuses": [
                        "active",
                        "paused"
                      ]
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "ContractConnection",
                "kind": "LinkedField",
                "name": "freelancerContracts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contract",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableTimesheets",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "allowExpensesAccess",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentsEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Firm",
                        "kind": "LinkedField",
                        "name": "firm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "slug",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
              },
              {
                "alias": "offers",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "statuses": [
                        "offer_made"
                      ]
                    }
                  },
                  (v3/*: any*/)
                ],
                "concreteType": "ContractConnection",
                "kind": "LinkedField",
                "name": "freelancerContracts",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "freelancerContracts(filters:{\"statuses\":[\"offer_made\"]},first:0)"
              },
              {
                "alias": "interviews",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "stage": "interview"
                    }
                  },
                  (v3/*: any*/)
                ],
                "concreteType": "JobApplicationConnection",
                "kind": "LinkedField",
                "name": "freelancerJobApplications",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "freelancerJobApplications(filters:{\"stage\":\"interview\"},first:0)"
              },
              {
                "alias": "screening",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "withJobScreening": true
                    }
                  },
                  (v3/*: any*/)
                ],
                "concreteType": "JobApplicationConnection",
                "kind": "LinkedField",
                "name": "freelancerJobApplications",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "freelancerJobApplications(filters:{\"withJobScreening\":true},first:0)"
              },
              {
                "alias": "applications",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filters",
                    "value": {
                      "statuses": [
                        "job_application_sent",
                        "job_application_draft"
                      ]
                    }
                  },
                  (v3/*: any*/)
                ],
                "concreteType": "JobApplicationConnection",
                "kind": "LinkedField",
                "name": "freelancerJobApplications",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_sent\",\"job_application_draft\"]},first:0)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMember",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClient",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezoneName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezoneOffset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "realUser",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteDebugCode",
                "storageKey": null
              },
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b729b7bdc640b166b4a03f2d899f2a40",
    "id": null,
    "metadata": {},
    "name": "masq_masqAsUserMutation",
    "operationKind": "mutation",
    "text": "mutation masq_masqAsUserMutation(\n  $input: MasqInput!\n) {\n  masq(input: $input) {\n    user {\n      id\n      ...NavigationWrapper_User\n    }\n  }\n}\n\nfragment NavigationWrapper_User on User {\n  ...Sidebar_User\n  ...user_useIsGuest\n  ...timezone_useTimezoneDetectorUser\n  ...user_useRemoteDebug\n  ...analytics_useAnalytics\n}\n\nfragment Sidebar_User on User {\n  ...user_useIsGuest\n  ...auth_useDefaultPath\n}\n\nfragment analytics_init on User {\n  isFlexhireTeam\n  realUser {\n    isFlexhireTeam\n    id\n  }\n  ...analytics_setUserInfo\n}\n\nfragment analytics_setUserInfo on User {\n  name\n  email\n  unconfirmedEmail\n  rawId\n  realUser {\n    rawId\n    name\n    email\n    unconfirmedEmail\n    id\n  }\n}\n\nfragment analytics_useAnalytics on User {\n  id\n  ...analytics_init\n}\n\nfragment auth_getDefaultPath on User {\n  confirmedEmail\n  passwordSetupRequired\n  status\n  activeContracts: freelancerContracts(first: 1, filters: {statuses: [active, paused]}) {\n    nodes {\n      enableTimesheets\n      allowExpensesAccess\n      paymentsEnabled\n      firm {\n        slug\n        id\n      }\n      id\n    }\n  }\n  offers: freelancerContracts(first: 0, filters: {statuses: [offer_made]}) {\n    totalCount\n  }\n  interviews: freelancerJobApplications(first: 0, filters: {stage: interview}) {\n    totalCount\n  }\n  screening: freelancerJobApplications(first: 0, filters: {withJobScreening: true}) {\n    totalCount\n  }\n  applications: freelancerJobApplications(first: 0, filters: {statuses: [job_application_sent, job_application_draft]}) {\n    totalCount\n  }\n  ...user_isMember\n  ...user_isClient\n  ...user_isGuest\n}\n\nfragment auth_useDefaultPath on User {\n  ...auth_getDefaultPath\n}\n\nfragment timezone_useTimezoneDetectorUser on User {\n  timezoneName\n  timezoneOffset\n  ...user_useIsGuest\n  ...user_useIsMasked\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n\nfragment user_useIsMasked on User {\n  id\n  realUser {\n    id\n  }\n}\n\nfragment user_useRemoteDebug on User {\n  remoteDebugCode\n}\n"
  }
};
})();

(node as any).hash = "d687b0b91aee501cd249494faaedbc12";

export default node;
